export function getLength(htmlString) {
  return htmlString.length;
  // const htmlObj = new DOMParser().parseFromString(htmlString, 'text/html');
  // const htmlAsString = htmlObj.body.innerText;
  //
  // return htmlAsString.length;
}
